import React from 'react';
import ContentReview from '@/components/ContentReview';

const ContentReviewPage: React.FC = () => {
  return <ContentReview />;
};

export default ContentReviewPage; 